import Vue from 'vue'
//@ts-ignore
import {toStringHDMS,Coordinate}  from 'ol/coordinate'


Vue.filter('formatEPSG4326ToHDMS', function(value:Coordinate, onlyLat:boolean|null=null) {
  if (value) {            
    const hdms = toStringHDMS(value)
    if(onlyLat == null) return hdms
    const hdmsPart = hdms.split(' ')
    if(onlyLat) return hdmsPart.slice(0,4).join(' ')
    else return hdmsPart.slice(4).join(' ')
  }
})